module.exports = __webpack_public_path__ + "images/pages/for_business/sp/case1_3216a197c04fdce82ea599221a02bf8e.png";